import React, { Component } from 'react';
import { element, arrayOf } from 'prop-types';
import './product.less';

export default class ProductGroup extends Component {
    render() {
        return (
            <ul className="products margin-top-medium">
                {this.props.children}
            </ul>
        );
    }
}

ProductGroup.propTypes = {
    children: arrayOf(element)
};
